import { Text } from "@simplybusiness/mobius";

import type { PaymentItem } from "./types";

export const PaymentItemRow = ({ labels, value }: PaymentItem) => (
  <>
    <div className="mobius-payment-items-section__labels">
      {labels.map(label => (
        <Text variant="small" spacing="tight" key={label}>
          {label}
        </Text>
      ))}
    </div>
    <Text
      variant="small"
      spacing="tight"
      className="mobius-payment-items-section__value"
    >
      {value}
    </Text>
  </>
);

PaymentItemRow.displayName = "PaymentItemRow";
